module.exports = __webpack_public_path__ + "static/assets/6e9b5898b906a3e68eadcad1bcdc51d3.gif";